export default __webpack_public_path__ + "static/banner-trabaja-nosotros-2022-b7bbf48f27a34e7a7e595df9e42b4020.jpeg";